import styled, { keyframes, css } from 'styled-components'
import icon from '@assets/images/icon-dropdown.svg'
import loading from '@assets/images/input-loading.svg'

const customProps = {
  padding: '10px',
  fontFamily: 'sans-serif',
  fontSize: '16px',
  colorText: '#555',
  borderColor: 'var(--dark-blue)',
}

const placeholderShow = css`
  top: -16px;
  font-size: 12px;
  left: 0;
`

const ContainerField = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-bottom: 15px;
  font-family: ${customProps.fontFamily};

  ${props =>
    props.isLoading &&
    css`
      &::after {
        content: url(${loading});
        color: #555;
        position: absolute;
        top: 0;
        right: calc(${customProps.padding} * 5);
        font-size: 26px;
        display: block;
      }
    `}

  ${props =>
    props.fixedLabel &&
    css`
      padding-top: 30px;
      select + label {
        ${placeholderShow}
      }
    `}

  &select + label,
  select:focus + label,
  select:not(:placeholder-shown) + label {
    ${placeholderShow}
  }

  &.required {
    select {
      border-color: var(--red);
    }
    /* i {
      background-color: var(--red);
    } */
    label {
      color: var(--red);
    }
  }
`

const Label = styled.label`
  position: absolute;
  top: calc(${customProps.padding} * 2);
  left: calc(${customProps.padding} * 2);
  font-size: 16px;
  transition: all 0.3s;
  padding: 0px 5px 0px 5px;
`

const HelpText = styled.div`
  font-size: 12px;
  padding: 1px 5px;
  color: #888;
  border-radius: 5px;
`

const MessageErrorBox = styled.span`
  background: var(--red);
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 0px 5px 0px 5px;
  font-size: 10px;
  display: inline-block;
  font-weight: bold;
  color: #fff;
  border-radius: 0px 5px 0px 5px;
`

const Option = styled.option`
  cursor: pointer;
  background-color: #fff;
  border: none;
`

const Select = styled.select`
  box-sizing: border-box;
  appearance: none;
  line-height: 100%;
  margin: 0;
  width: 100%;
  height: 40px;
  font-size: ${customProps.fontSize};
  padding: ${customProps.padding};
  border: 1px solid ${customProps.borderColor};
  border-radius: 5px;
  cursor: pointer;
  background-color: transparent;

  &:disabled {
    color: #aaa;
    background: #eee;
    cursor: default;
    user-select: none;
    pointer-events: none;
  }

  &:disabled + label {
    background: transparent;
    cursor: default;
    user-select: none;
    pointer-events: none;
  }
`

const Icon = styled.i`
  background-image: url(${icon});
  background-color: var(--dark-blue);
  background-repeat: no-repeat;
  background-position: center;
  width: 16px;
  height: 16px;
  display: block;
  border-radius: 20px;
  position: absolute;
  top: 12px;
  right: 15px;
  z-index: -1;
  cursor: pointer;
`

export { ContainerField, Label, HelpText, Select, Option, Icon, MessageErrorBox }
